import React from 'react';

import ADGMPanelInputsGeneratorBody from 'aurora-components/ADGMPanelInputsGenerator/ADGMPanelInputsGeneratorBody';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { Grid, Avatar, Box, Hidden } from '@material-ui/core';
import { ADGMPanel } from 'aurora-components';

import CompanyImage from 'aurora-images/Company_avatar.svg';
import UserImage from 'aurora-images/user_profileV3.svg';
import { keyEmptyCheck } from 'aurora-utils/utils';
import withStyles from '@material-ui/core/styles/withStyles';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useHelpers from './helpers';
import SelectCard from './SelectCard';
import styles from './styles';

const FetchedEntity = ({ classes, entityDetails, serviceLabel, activeEntity, setActiveEntity, intl }) => {
  const { locale } = useSelector(state => state.language);
  const isCompany = entityDetails?.type === 'COMPANY';
  const isUAEResident = entityDetails?.type === 'UAE_RESIDENT';
  const isNONUAEResident = entityDetails?.type === 'NON_UAE_RESIDENT';
  const isGovernment = entityDetails?.type === 'GOVERNMENT';
  const { SECTION_EXTRA_FIELDS } = useHelpers({ intl });
  console.log('SECTION_EXTRA_FIELDS', SECTION_EXTRA_FIELDS);

  const EntityDataToBeShown = [
    ...(isCompany
      ? [
          { label: 'Name', value: entityDetails?.[locale === 'ar' ? 'companyNameAr' : 'companyNameEn'] },
          { label: 'Trade_license_number', value: entityDetails?.tradeLicenseNumber },
          { label: 'phone_number', value: entityDetails?.mobileNumber },
          { label: 'Email', value: entityDetails?.companyEmail },
        ]
      : []),
    ...(isUAEResident || isNONUAEResident
      ? [
          { label: 'Name', value: entityDetails?.[locale === 'ar' ? 'nameAr' : 'nameEn'] },
          ...(isUAEResident
            ? [{ label: 'EID_Number', value: entityDetails?.eid }]
            : [{ label: 'Passport_number', value: entityDetails?.passportNumber }]),
          { label: 'Nationality', value: entityDetails?.[locale === 'ar' ? 'nationalityAr' : 'nationalityEn'] },
          { label: 'phone_number', value: entityDetails?.phoneNumber },
          { label: 'Email', value: entityDetails?.email },
        ]
      : []),
  ];

  return (
    <div className={classes.wrapper}>
      {isGovernment ? (
        <SelectCard
          locale={locale}
          activeEntity={activeEntity}
          setActiveEntity={setActiveEntity}
          classes={classes}
          entityDetails={entityDetails}
        />
      ) : (
        <ADGMPanel title={keyEmptyCheck('entity_details', { entity: serviceLabel })}>
          <Grid>
            <Box className={classNames([classes.container, classes.detailBody])} sx={{ display: 'flex' }}>
              <Hidden smDown>
                <Box item md={1} xs={2}>
                  <Avatar className={classes.avatarImg} alt='avatar img' src={isCompany ? CompanyImage : UserImage} />
                </Box>
              </Hidden>

              <Box item md={11} xs={12} style={{ width: '100%' }}>
                <Grid container spacing={4} className={classes.detailsContainer}>
                  {EntityDataToBeShown.map(({ label, value }) => (
                    <Grid item xs={12} md={4} key={label}>
                      {label === 'Name' ? (
                        <Grid container>
                          <Hidden mdUp>
                            <Box item md={1} xs={2}>
                              <Avatar
                                className={classes.avatarImg}
                                alt='avatar img'
                                src={isCompany ? CompanyImage : UserImage}
                              />
                            </Box>
                          </Hidden>
                          <Box item md={11} xs={10}>
                            <ADGMItemDetails
                              label={label}
                              value={value}
                              labelClass={classes.lightThinLabel}
                              valueClass={classes.lightThinValue}
                            />
                          </Box>
                        </Grid>
                      ) : (
                        <ADGMItemDetails
                          label={label}
                          value={value}
                          labelClass={classes.lightThinLabel}
                          valueClass={classes.lightThinValue}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          </Grid>
          <ADGMPanelInputsGeneratorBody
            isEditable
            title=''
            sections={SECTION_EXTRA_FIELDS}
            classes={{
              containerPadding: classes.modalContainerModified,
              sectionTitle: classes.modalSectionTittle,
              titleWrapper: classes.modalTitleWrapper,
            }}
          />
        </ADGMPanel>
      )}
    </div>
  );
};

FetchedEntity.propTypes = {
  intl: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  entityDetails: PropTypes.object.isRequired,
  type: PropTypes.string,
  serviceLabel: PropTypes.string.isRequired,
  activeEntity: PropTypes.object,
  setActiveEntity: PropTypes.func,
};

FetchedEntity.defaultProps = {
  type: '',
  activeEntity: {},
  setActiveEntity: () => {},
};
export default withStyles(styles)(injectIntl(FetchedEntity));
